import { render, staticRenderFns } from "./medkitlogFirstAid.vue?vue&type=template&id=71c83b02"
import script from "./medkitlogFirstAid.vue?vue&type=script&lang=js"
export * from "./medkitlogFirstAid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports